import React from 'react';
import { Route, Routes } from 'react-router-dom';
import LeadManagement from './LeadManagement.tsx';

const LeadsV1 = () => {
  return (
    <Routes>
      <Route exact path='' element={<LeadManagement/>}/>
    </Routes>
  );
};
export default LeadsV1;
